import accountsPageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';
import _ from 'lodash';

const INITIAL_STATE = {
  dialogs: {
    groupAddUser: {
      isOpen: false,
      props: {},
    },
    groupDeleteUser: {
      isOpen: false,
      props: {},
    },
  },
  createdLogoUrl: null,
  isUploadingLogo: false,
};

const reducer = createReducer(INITIAL_STATE, {
  [accountsPageActionTypes.ACCOUNTS_PAGE_DIALOG_OPEN]: (
    state: any,
    action: any,
  ) => {
    if (
      !Object.prototype.hasOwnProperty.call(state.dialogs, action.dialog) ||
      !action.dialog
    )
      return state;
    return _.merge({}, state, {
      dialogs: {
        [action.dialog]: {
          isOpen: true,
          props: action.props,
        },
      },
    });
  },
  [accountsPageActionTypes.ACCOUNTS_PAGE_DIALOG_CLOSE]: (
    state: any,
    action: any,
  ) => {
    if (
      !Object.prototype.hasOwnProperty.call(state.dialogs, action.dialog) ||
      !action.dialog
    )
      return state;
    return _.merge({}, state, {
      dialogs: {
        [action.dialog]: {
          isOpen: false,
          props: {},
        },
      },
    });
  },
  [accountsPageActionTypes.ACCOUNTS_PAGE_SET_CREATED_LOGO_URL]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      createdLogoUrl: action.url,
    };
  },
  [accountsPageActionTypes.ACCOUNTS_PAGE_SET_IS_UPLOADING]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isUploadingLogo: action.isUploading,
    };
  },
});

export default reducer;
